import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { UpdateToast } from '@/components/UpdateToast';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { Analytics } from '@/pages/Analytics';
import { Users } from '@/pages/Users';
import { Content } from '@/pages/Content';
import { Localizacao } from '@/pages/Localizacao';
import { Reports } from '@/pages/Reports';
import { Monetizacao } from '@/pages/Monetizacao';
import { Pro } from '@/pages/Pro';
import { Atividade } from '@/pages/Atividade';
import { Financas } from '@/pages/Financas';
import { Configuracoes } from '@/pages/Configuracoes';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-text-muted">
        carregando…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/"          element={<Protected><Dashboard /></Protected>} />
        <Route path="/analytics" element={<Protected><Analytics /></Protected>} />
        <Route path="/users"     element={<Protected><Users /></Protected>} />
        <Route path="/localizacao" element={<Protected><Localizacao /></Protected>} />
        <Route path="/content"   element={<Protected><Content /></Protected>} />
        <Route path="/reports"   element={<Protected><Reports /></Protected>} />
        {/* /plays deprecado 2026-07-08 — consolidado em /content (Sprint 2.3). */}
        <Route path="/plays"     element={<Navigate to="/content" replace />} />
        <Route path="/monetizacao"   element={<Protected><Monetizacao /></Protected>} />
        <Route path="/pro"           element={<Protected><Pro /></Protected>} />
        <Route path="/atividade"     element={<Protected><Atividade /></Protected>} />
        <Route path="/financas"      element={<Protected><Financas /></Protected>} />
        <Route path="/configuracoes" element={<Protected><Configuracoes /></Protected>} />
        <Route path="*"          element={<Navigate to="/" replace />} />
      </Routes>
      {/* Toast global — aparece em qualquer rota quando novo deploy é
          detectado. Fica fora de <Routes> pra sobreviver a navegações. */}
      <UpdateToast />
    </>
  );
}
